import React from "react";
import { withRouter } from "react-router-dom";
import withFirebase from "../hoc/withFirebase";
import withUser from "../hoc/withUser";
import AddOrganisation from "../components/AddOrganisation";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
class AddOrganisationContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deals: [],
      isLoading: true,
      organisations: []
    };
  }
  componentWillMount() {
    this.fetchOrganisations();
  }
  fetchOrganisations = () => {
    this.props.db
      .collection("organisations")
      .where("createdBy", "==", this.props.user.uid)
      .onSnapshot(querySnapshot => {
        const organisations = [];
        querySnapshot.forEach(doc => {
          const singleOrganisation = doc.data();
          singleOrganisation.OrganisationId = doc.id;
          organisations.push(singleOrganisation);
        });
        this.setState({ organisations, isLoading: false });
        if (this.state.organisations.length > 0) {
          this.props.history.push("/deals");
        } else {
          return;
        }
      });
  };
  addOrganisation = organisation => {
    this.props.db
      .collection("organisations")
      .add(organisation)
      .then(docRef => {
        this.props.db
          .collection("users")
          .doc(organisation.createdBy)
          .update({
            organisationId: docRef.id
          });
      });
  };
  render() {
    const { user } = this.props;
    const { organisations, isLoading } = this.state;
    return isLoading ? (
      ""
    ) : (
      <Route
        exact
        path="/addOrganisation"
        render={props => (
          <AddOrganisation
            addOrganisation={this.addOrganisation}
            user={user}
            organisations={organisations}
          />
        )}
      />
    );
  }
}

export default withRouter(withUser(withFirebase(AddOrganisationContainer)));
